







































import { computed, defineComponent, PropType } from 'vue';
import { FullEventModel } from '../../../../shared/models/fullEvent.model';
import EventDetailsAttachments from './EventDetailsAttachments.vue';
import { getLessonNoteAttachments } from '../../../../shared/composables/useLessonNoteAttachments';

export default defineComponent({
  components: { EventDetailsAttachments },
  props: {
    eventData: { type: Object as PropType<FullEventModel>, required: true },
  },
  emits: ['openAttachment'],
  setup(props, { emit }) {
    const content = computed(() => props.eventData.description?.html ?? '');
    const isLesson = computed(() => props.eventData.lesson != null);
    const hasAttachments = computed(() => (props.eventData.attachments?.length ?? 0) > 0);
    const lessonAttachments = computed(() => getLessonNoteAttachments(props.eventData.lesson));
    const noteToClass = computed(() => props.eventData.lesson?.noteToClass?.html ?? '');
    const noteToTeacher = computed(() => props.eventData.lesson?.noteToTeacher?.html ?? '');
    const noteToSubstitute = computed(() => props.eventData.lesson?.noteToSubstitute?.html ?? '');
    const classAttachments = computed(() => lessonAttachments.value.attachmentsForClass);
    const teacherAttachments = computed(() => lessonAttachments.value.attachmentsForTeacher);
    const substituteAttachments = computed(() => lessonAttachments.value.attachmentsForSubstitute);
    const hasClassLessonContent = computed(() => Boolean(noteToClass.value || classAttachments.value.length > 0));
    const hasTeacherLessonContent = computed(() => Boolean(noteToTeacher.value || teacherAttachments.value.length > 0));
    const hasSubstituteLessonContent = computed(
      () => Boolean(noteToSubstitute.value || substituteAttachments.value.length > 0)
    );
    const hasContent = computed(() => {
      if (isLesson.value) {
        return hasClassLessonContent.value || hasTeacherLessonContent.value || hasSubstituteLessonContent.value;
      }

      return Boolean(content.value || hasAttachments.value);
    });

    const emitOpenAttachment = (data: unknown) => {
      emit('openAttachment', data);
    };

    return {
      classAttachments,
      content,
      emitOpenAttachment,
      hasClassLessonContent,
      hasAttachments,
      hasContent,
      hasSubstituteLessonContent,
      hasTeacherLessonContent,
      isLesson,
      noteToClass,
      noteToSubstitute,
      noteToTeacher,
      substituteAttachments,
      teacherAttachments,
    };
  },
});
